import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Trophy, Target, Zap, Users } from 'lucide-react';
import { CTABand } from '../components/CTABand';
export function CompetitionTeam() {
  useEffect(() => {
    document.title = 'Competition Team | Storm Taekwondo';
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-442">
      {/* Hero */}
      <section className="relative bg-ink pt-16 pb-24 overflow-hidden" data-id="element-443">
        <div className="absolute inset-0 opacity-40" data-id="element-444">
          <img src="https://cdn.magicpatterns.com/uploads/36vtLMum6Tc21F2FXt8jPS/Comp.png" alt="Competition Taekwondo" className="w-full h-full object-cover" data-id="element-445" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-446" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-447">
          <div className="max-w-2xl" data-id="element-448">
            <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-449">
              <Trophy className="w-4 h-4" data-id="element-450" />
              Elite Training
            </div>
            <h1 className="text-5xl md:text-6xl text-white mb-6 uppercase tracking-tight" data-id="element-451">
              Team Storm Competition Team
            </h1>
            <p className="text-xl text-off-white mb-8 leading-relaxed" data-id="element-452">
              For students ready to push their limits and compete at the highest
              levels. Led by experienced champions, Team Storm prepares athletes
              for local, state, and national Olympic-style Taekwondo
              tournaments.
            </p>
            <Link to="/contact" className="btn-primary" data-id="element-453">
              Inquire About Tryouts
            </Link>
          </div>
        </div>
      </section>

      {/* Details Grid */}
      <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-454">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-455">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-456">
            <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-457">
              <Trophy className="w-10 h-10 text-storm-red mb-6" data-id="element-458" />
              <h3 className="text-2xl text-ink mb-3" data-id="element-459">Elite Coaching</h3>
              <p className="text-gray-warm" data-id="element-460">
                Train under Chief Instructor Megan Merem, a 2x USA National
                Sparring Champion, and our dedicated coaching staff.
              </p>
            </div>
            <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-461">
              <Zap className="w-10 h-10 text-storm-red mb-6" data-id="element-462" />
              <h3 className="text-2xl text-ink mb-3" data-id="element-463">Advanced Sparring</h3>
              <p className="text-gray-warm" data-id="element-464">
                Learn high-level tactics, timing, distance management, and
                Olympic-style scoring techniques.
              </p>
            </div>
            <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-465">
              <Target className="w-10 h-10 text-storm-red mb-6" data-id="element-466" />
              <h3 className="text-2xl text-ink mb-3" data-id="element-467">Mental Toughness</h3>
              <p className="text-gray-warm" data-id="element-468">
                Develop the resilience, focus, and grit required to perform
                under pressure on the competition mat.
              </p>
            </div>
            <div className="bg-off-white p-8 rounded-2xl border border-subtle-gray" data-id="element-469">
              <Users className="w-10 h-10 text-storm-red mb-6" data-id="element-470" />
              <h3 className="text-2xl text-ink mb-3" data-id="element-471">Team Camaraderie</h3>
              <p className="text-gray-warm" data-id="element-472">
                Join a tight-knit family of dedicated athletes who push each
                other to be their absolute best.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Schedule Note */}
      <section className="py-24 bg-ink text-white text-center" data-id="element-473">
        <div className="max-w-3xl mx-auto px-4" data-id="element-474">
          <h2 className="text-4xl mb-6" data-id="element-475">Intensive Saturday Training</h2>
          <p className="text-xl text-gray-warm mb-8" data-id="element-476">
            Team Storm currently meets every Saturday from 7:00 PM to 9:00 PM
            for intensive sparring, conditioning, and tournament preparation.
          </p>
          <div className="inline-block border border-subtle-gray/30 bg-charcoal px-8 py-4 rounded-xl" data-id="element-477">
            <p className="font-bold text-lg uppercase tracking-wide text-storm-red" data-id="element-478">
              Invite Only / Tryout Required
            </p>
          </div>
        </div>
      </section>

      <CTABand headline="Ready to Step on the Mat?" copy="If you are a current student interested in competing, or an experienced athlete looking for a new team, contact us to discuss tryout opportunities." data-id="element-479" />
    </div>;
}